import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  // Remplacez par vos propres informations de configuration Firebase
  apiKey: "AIzaSyCIl_iQDIA-jGF0lXoK7OOAwLeJjw_YnIQ",
  authDomain: "equitas-hate-tracker.firebaseapp.com",
  projectId: "equitas-hate-tracker",
  storageBucket: "equitas-hate-tracker.firebasestorage.app",
  messagingSenderId: "863799684604",
  appId: "1:863799684604:web:f59210da2880db8dfa9679",
  measurementId: "G-BRLCL0Z0HN"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app); 